import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Modal,
  CircularProgress,
  Paper,
  TextField,
  Typography,
  Avatar,
  Badge,
  Checkbox,
  ListItemText,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { height, Stack, width } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { styled } from "@mui/material/styles";
import { createPartnerAction } from "../../redux/toolkit/partner/createPartner";
import { uplodImageAction } from "../../redux/toolkit/image/uplodImage";
import SnackBarUI from "../../comman/SnackBarUI";
import { getAllPartnerAction } from "../../redux/toolkit/partner/allPartner";

import InputLabel from "@mui/material/InputLabel";
// import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import { createVideoAction } from "../../redux/toolkit/video/createVideo";
import { getAllVideoAction } from "../../redux/toolkit/video/allVideo";

const partnerSchema = yup
  .object({
    videoLink: yup.string().required("Video Link is required"),
    timeGap: yup.number().required("Time Gap is required"),
    dailyLimit: yup.number().required("Daily Limit is required"),
    // continue_frequency: yup.string().required("continue_frequency is required"),
  })
  .required();

const AddVideo = ({ state, setState }) => {
  const [snack, setSnack] = useState(false);
  const [partner, setPartner] = useState("");
  const [triggerValue, setTriggerValue] = useState(0);

  const dispatch = useDispatch();

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);

  const {
    register,
    setValue,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(partnerSchema) });
  const skipStatusWatch = watch("skipStatus");

  const handleClose = () => {
    setState(false);
  };

  let triggerArr = [
    "profiler Start",
    "profiler Complete",
    "survey complete",
    "survey disqualification",
    "Partner Open",
  ];

  const videoData = useSelector((state) => state.createVideo);
  const { status, message, loading } = videoData;

  const handleAddPartner = async (data) => {
    setState(false);
    const createVideo = await dispatch(
      createVideoAction({
        ...data,
        triggerpoints: triggerValue,
        partnerId: partner,
      })
    );
    if (createVideo?.payload?.status === 200) {
      setSnack(true);
      await dispatch(getAllVideoAction());
    }
  };

  const handlePartnerChange = (event) => {
    setPartner(event.target.value);
  };

  const handleChange = (event) => {
    setTriggerValue(event.target.value);
  };

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  return (
    <>
      <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
        <Box className="modal_box">
          <Card sx={{ width: 500, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Create Video
            </Typography>

            <form
              sx={{ height: "auto" }}
              onSubmit={handleSubmit(handleAddPartner)}
            >
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Select Trigger Point</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={triggerValue}
                        onChange={handleChange}
                        label="Select Trigger Point"
                        
                      >
                       
                        {triggerArr.map((item, index) => (
                          <MenuItem value={index+1}>
                            {" "}
                            {triggerArr[index]}{" "}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ minWidth: 120, marginBottom: "20px" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Select Partner
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled={triggerValue === 5 ? false : true}
                        value={partner}
                        label="Select Partner"
                        onChange={handlePartnerChange}
                      >
                        {partnerDetails?.data?.map((item) => {
                          return (
                            <MenuItem value={item._id}>{item.name}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="videoLink"
                    variant="outlined"
                    placeholder="videoLinkame"
                    {...register("videoLink")}
                    error={!!errors?.videoLink?.message}
                    helperText={errors?.videoLink?.message}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="timeGap"
                    variant="outlined"
                    placeholder="timeGap"
                    {...register("timeGap")}
                    error={!!errors?.timeGap?.message}
                    helperText={errors?.timeGap?.message}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        {...register("isActive")}
                        color="primary"
                        defaultChecked={false}
                      />
                    }
                    label="Is Active"
                  />
                  {errors?.isActive && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.isActive.message}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        {...register("skipStatus.isSkip")}
                        color="primary"
                        defaultChecked={false} // matches schema default
                      />
                    }
                    label="Skip?"
                  />
                  {errors?.skipStatus?.isSkip && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.skipStatus.isSkip.message}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="SkipStatus Time Gap"
                    disabled={!skipStatusWatch?.isSkip}
                    variant="outlined"
                    type="number"
                    placeholder="Enter time gap"
                    {...register("skipStatus.timeGap", { valueAsNumber: true })}
                    error={!!errors?.skipStatus?.timeGap}
                    helperText={errors?.skipStatus?.timeGap?.message}
                  />
                </Grid>

                {/* // timeGap (Number) */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="dailyLimit"
                    variant="outlined"
                    type="number"
                    placeholder="Enter dailyLimit"
                    {...register("dailyLimit", { valueAsNumber: true })}
                    error={!!errors?.dailyLimit}
                    helperText={errors?.dailyLimit?.message}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        {...register("isGlobal")}
                        color="primary"
                        defaultChecked={false} // matches schema default
                      />
                    }
                    label="isGlobal?"
                  />
                  {errors?.isGlobal && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.skipStatus.isSkip.message}
                    </p>
                  )}
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="dailyTriggerHits"
                    variant="outlined"
                    type="number"
                    disabled = {(triggerValue === 3 || triggerValue === 4) ? false : true}
                    placeholder="Enter dailyTriggerHits"
                    {...register("dailyTriggerHits", { valueAsNumber: true })}
                    error={!!errors?.dailyTriggerHits}
                    helperText={errors?.dailyTriggerHits?.message}
                  />
                </Grid>

              </Grid>

              <Stack direction="row" spacing={2} mt={3}>
                <Button
                  sx={{ zIndex: 1000 }}
                  variant="contained"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <CircularProgress /> : "Create Video"}
                </Button>

                <Button variant="contained" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default AddVideo;
